import { useCallback, useEffect, useState } from 'react';
import { useSnackbar } from 'notistack';
import { SpreadsheetNotesService } from 'api';
import { SpreadsheetNoteData } from 'components/SpreadsheetNotes';
import { onDeleteNote } from 'services/hooks/spreadsheetNotes/utilities';
import logger from 'utilities/logger';

const useSpreadsheetNotes = () => {

  const [spreadsheetNotes, setSpreadsheetNotes] = useState<SpreadsheetNoteData[]>([]);
  const [hasChanged, setHasChanged] = useState<boolean>(false);
  const { enqueueSnackbar } = useSnackbar();

  const saveSpreadsheetNotes = useCallback(async () => {
    try {
      await SpreadsheetNotesService.apiSpreadsheetNotesCreate(spreadsheetNotes)
      setSpreadsheetNotes([])
    } catch (error) {
      logger.error('Error saving notes', error);
      enqueueSnackbar('Error saving notes', { variant: 'error' });
    }
  }, [spreadsheetNotes, enqueueSnackbar]);

  const handleOnDeleteNote = useCallback((noteToDelete: SpreadsheetNoteData) => {
    onDeleteNote({
      notes: spreadsheetNotes ?? [],
      setNotes: setSpreadsheetNotes,
      updatedNote: noteToDelete,
    });
    setHasChanged(true);
  }, [spreadsheetNotes])

  useEffect(() => {
    setHasChanged(true);
  }, [spreadsheetNotes]);

  return {spreadsheetNotes, setSpreadsheetNotes, saveSpreadsheetNotes, hasChanged, handleOnDeleteNote};
}

export default useSpreadsheetNotes;